import { Card } from "@mui/material";
import "./PersonalInformation.scss";
import { Field, Formik } from "formik";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import {
  ADMIN_ROLES,
  API_RESPONSE,
  COMMON_CONSTANTS,
  I18_TRANSLATION_COMMON,
  NUMBER_CONSTANTS,
  PERSONAL_INFORMATION,
  ROUTES,
  STORAGE_KEYS,
  TOASTER_CONFIGS,
  VALIDATION_CONSTANT,
} from "../../../../Utilities/Constants/Constants";
import uploadImage from "../../../../../Assets/Registration/feather_upload-cloud-icon.svg";
import { FileUploader } from "react-drag-drop-files";
import { useEffect, useRef, useState } from "react";
import {
  GetSessionStorageData,
  S3DataGetApi,
  uploadFileToS3,
} from "../../../../Services/Helpers/Helper";
import {
  REGEX,
  REGISTRATION_ERRORS,
} from "../../../../Utilities/Constants/Validations";
import { toast } from "react-toastify";
import driveImg from "../../../../../Assets/Registration/drive.svg";
import { axiosInstance } from "../../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../../Utilities/Constants/ApiEndpoints";
import FileViewerDialog from "../../../../Shared/FileViewerDialog/FileViewerDialog";
import closeIcon from "../../../../../Assets/Sessions/close.svg";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation } from "react-router-dom";
import { store } from "../../../../Services/Redux/Store/Store";
import { setLoader } from "../../../../Services/Redux/Reducer/Reducer";
import { useSelector } from "react-redux";

const PersonalInformation = (props: any) => {
  const { t, i18n } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const [currentUpload, setCurrentUpload] = useState("");
  const [userType, setuserType]: any = useState("");
  const infoValidationSchema = yup.object({
    [PERSONAL_INFORMATION.EMIRATES_ID]: yup
      .string()
      .matches(REGEX.EMIRATES_ID, REGISTRATION_ERRORS.VALID_EMIRATES_ID)
      .required(REGISTRATION_ERRORS.EMIRATES_ID),
    [PERSONAL_INFORMATION.IMMIGRANT_ID]: yup
      .string()
      .nullable(),
    [PERSONAL_INFORMATION.TRADE_ID]: userType === 5 ? yup.string().required(REGISTRATION_ERRORS.TRADE_ID) : yup.string().nullable()
  });
  const [viewerFile, setViewerFile] = useState("");
  const uploadFileRef = useRef<HTMLInputElement | null>(null);
  const uploadFileBtnRef = useRef<HTMLInputElement | null>(null);
  const campBroucherRef = useRef<HTMLInputElement | null>(null);
  const emiratesBackBtnRef = useRef<HTMLInputElement | null>(null);
  const emiratesFrontBtnRef = useRef<HTMLInputElement | null>(null);
  const immigrantFrontBtnRef = useRef<HTMLInputElement | null>(null);
  const immigrantBackBtnRef = useRef<HTMLInputElement | null>(null);
  const profileBtnRef = useRef<HTMLInputElement | null>(null);
  const certificateBtnRef = useRef<HTMLInputElement | null>(null);
  const tradelicenceBtnRef = useRef<HTMLInputElement | null>(null);
  // const profileBtnRef = useRef<HTMLInputElement | null>(null);
  const [emirates_front, setEmiratesFront] = useState("");
  const [emirates_back, setEmiratesBack] = useState("");
  const [immigrant_front, setImmigrantFront] = useState("");
  const [immigrant_back, setImmigrantBack] = useState("");
  const [profileImage, setProfileImage] = useState("");
  const [certificates, setCertificates]: any = useState([]);
  const [tradelicence, setTradelicence]: any = useState("");
  const [campBrouchers, setCampBrouchers]: any = useState([]);
  const [tutorCV, setTutorCV] = useState("");
  const [emiratesId, setEmiratesId] = useState("");
  const [immigrantId, setImmigrantId] = useState("");
  const [submitted, setSubmitted] = useState(API_RESPONSE.FALSE);
  const [fileViewerOpen, setFileViewerOpen] = useState(API_RESPONSE.FALSE);
  const [personalDetail, setPersonalDetail]: any = useState({});
  const [isSchoolUniversityReg, setIsSchoolUniversityReg] = useState(API_RESPONSE.FALSE);
  const [editable, setEditable] = useState(API_RESPONSE.TRUE);
  const [initialValue, setInitialValue] = useState({
    [PERSONAL_INFORMATION.EMIRATES_ID]: "",
    [PERSONAL_INFORMATION.IMMIGRANT_ID]: "",
    [PERSONAL_INFORMATION.TRADE_ID]: "",
  });
  const location = useLocation();
  const handleBtnClick = (uploadValue: any) => {
    // setUploadType(PERSONAL_INFORMATION.SELECT);
    // setCurrentUpload(uploadValue);
    uploadFileBtnRef.current?.click();
  };

  const aws: any = useSelector((state: any) => {
    return state.awsReducer.aws;
  });

  useEffect(() => {
    setuserType(GetSessionStorageData(STORAGE_KEYS.ROLE));
  }, []);

  useEffect(() => {
    if (userType == ADMIN_ROLES.UNIVERSITY || userType === ADMIN_ROLES.SCHOOL) {
      setIsSchoolUniversityReg(API_RESPONSE.TRUE)
    } else {
      setIsSchoolUniversityReg(API_RESPONSE.FALSE)
    }
    if (userType == `${NUMBER_CONSTANTS.FIVE}`) {
      getRegistrationDetail(API_END_POINTS.GET_CAMP_DETAILS);
    } else if (userType == `${NUMBER_CONSTANTS.NINE}`) {
      getRegistrationDetail(API_END_POINTS.GET_PERSONAL_DETAILS);
    } else if (userType == `${NUMBER_CONSTANTS.FOUR}`) {
      getRegistrationDetail(API_END_POINTS.GET_SPDETAILS);
    } else if (userType == ADMIN_ROLES.SCHOOL || userType === ADMIN_ROLES.UNIVERSITY) {
      getRegistrationDetail(API_END_POINTS.SCHOOL_UNIVERSITY_DETAILS);
    }
  }, [userType]);

  /* Handling drag over */
  const handleDragOver = (event: any) => {
    event.preventDefault();
  };

  /**Handle file viewer dialog close */
  const onFilerViewerDialogClose = () => {
    setFileViewerOpen(API_RESPONSE.FALSE);
    setViewerFile("");
  };

  /**Handle file viewer dialog open */
  const onFilerViewerDialogOpen = (url: any) => {
    setViewerFile(url);
    setFileViewerOpen(API_RESPONSE.TRUE);
  };

  const setDetails = () => {
    setEmiratesFront(personalDetail.emirates_front);
    setEmiratesBack(personalDetail.emirates_back);
    setImmigrantFront(personalDetail.immigrant_front);
    setImmigrantBack(personalDetail.immigrant_back);
    setProfileImage(personalDetail.profile_image);
    setCertificates(personalDetail.certificates ? personalDetail.certificates : []);
    setTradelicence(personalDetail.trade_license);
    setTutorCV(
      userType === `${NUMBER_CONSTANTS.FOUR}`
        ? personalDetail.tutor_cv
        : userType === `${NUMBER_CONSTANTS.THREE}` ? personalDetail.educational_expert_cv : personalDetail.trainer_cv
    );
  };

  useEffect(() => {
    if (personalDetail) setDetails();
  }, [personalDetail]);

  const getRegistrationDetail = (END_POINT: any) => {
    axiosInstance.get(END_POINT).then((response) => {
      if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
        setEditable((prev) => response.data.result.data[NUMBER_CONSTANTS.ZERO]?.status === "approved" ? API_RESPONSE.FALSE : API_RESPONSE.TRUE);
        setPersonalDetail(response.data.result.data[NUMBER_CONSTANTS.ZERO]);
        if (
          userType === `${NUMBER_CONSTANTS.FIVE}` &&
          response.data.result.data[NUMBER_CONSTANTS.ZERO].camp_broucher
        ) {
          setCampBrouchers(
            response.data.result.data[NUMBER_CONSTANTS.ZERO].camp_broucher
          );
        }
        setInitialValue({
          [PERSONAL_INFORMATION.EMIRATES_ID]:
            response.data.result.data[NUMBER_CONSTANTS.ZERO].emirates_id,
          [PERSONAL_INFORMATION.IMMIGRANT_ID]:
            response.data.result.data[NUMBER_CONSTANTS.ZERO].immigrant_id,
          [PERSONAL_INFORMATION.TRADE_ID]:
            response.data.result.data[NUMBER_CONSTANTS.ZERO].trade_id,
        });
      }
    });
  };

  const setFiles = (uploadedImage: any) => {
    switch (currentUpload) {
      case PERSONAL_INFORMATION.EMIRATES_FRONT:
        setEmiratesFront(uploadedImage);
        break;

      case PERSONAL_INFORMATION.EMIRATES_BACK:
        setEmiratesBack(uploadedImage);
        break;

      case PERSONAL_INFORMATION.IMMIGRANT_FRONT:
        setImmigrantFront(uploadedImage);
        break;

      case PERSONAL_INFORMATION.IMMIGRANT_BACK:
        setImmigrantBack(uploadedImage);
        break;

      case PERSONAL_INFORMATION.PROFILE_IMAGE:
        setProfileImage(uploadedImage);
        break;

      case PERSONAL_INFORMATION.CERTIFICATES:
        const data = [...certificates, uploadedImage];
        setCertificates(data);
        break;

      case PERSONAL_INFORMATION.TRADE_LICENCE:
        // const trade_data = [...tradelicence, uploadedImage];
        setTradelicence(uploadedImage);
        break;
  

      case PERSONAL_INFORMATION.CAMP_BROUCHER:
        const campData = [...campBrouchers, uploadedImage];
        setCampBrouchers(campData[0]);
        break;

      case PERSONAL_INFORMATION.TUTOR_CV:
        setTutorCV(uploadedImage);
        break;
    }
  };

  /* Media upload function */
  const uploadFiles = async (file: any) => {
    store.dispatch(setLoader(true));
    const uploadedImage: any = await S3DataGetApi(file);
    setFiles(uploadedImage);
    store.dispatch(setLoader(false));
  };

  const [dropEvent, setDropEvent]: any = useState();
  const [uploadType, setUploadType] = useState("");
  useEffect(() => {
    if (currentUpload && dropEvent) {
      uploadType === PERSONAL_INFORMATION.DROP
        ? uploadFiles(dropEvent)
        : uploadFiles(dropEvent);
    }
  }, [dropEvent]);

  const checkUploadType = (
    event: any,
    uploadValue: any,
    uploadingType: any
  ) => {
    store.dispatch(setLoader(true));
    setCurrentUpload(uploadValue);
    setUploadType(uploadingType);
    return new Promise((resolve, reject) => {
      const eventValue: any =
        uploadingType === PERSONAL_INFORMATION.DROP
          ? event.dataTransfer.files
          : event.target.files;
      if (
        uploadValue === PERSONAL_INFORMATION.CERTIFICATES ||
        uploadValue === PERSONAL_INFORMATION.CAMP_BROUCHER || uploadValue === PERSONAL_INFORMATION.TRADE_LICENCE

      ) {
        if (
          uploadValue === PERSONAL_INFORMATION.CERTIFICATES
            ? certificates?.length + eventValue?.length <=
            NUMBER_CONSTANTS.THREE
            : eventValue?.length <= NUMBER_CONSTANTS.ONE

          // campBrouchers?.length + eventValue?.length <=
          // NUMBER_CONSTANTS.THREE
        ) {
          const isValid: any = [...eventValue].every((media: any) => {
            if (
              media.type.split("/")[NUMBER_CONSTANTS.ONE] ===
              COMMON_CONSTANTS.PDF ||
              media.type.split("/")[NUMBER_CONSTANTS.ZERO] ===
              COMMON_CONSTANTS.IMAGE
            ) {
              return API_RESPONSE.TRUE;
            }
            return API_RESPONSE.FALSE;
          });

          if (isValid) {
            resolve(API_RESPONSE.TRUE);
            store.dispatch(setLoader(false));
          } else {
            reject(API_RESPONSE.FALSE);
            store.dispatch(setLoader(false));
          }
        } else {
          reject(REGISTRATION_ERRORS.CERTIFICATE_LIMIT);
          store.dispatch(setLoader(false));
        }
      } else if (uploadValue === PERSONAL_INFORMATION.TUTOR_CV) {
        const isValid: any = [...eventValue].every((media: any) => {
          store.dispatch(setLoader(false));
          if (
            media.type.split("/")[NUMBER_CONSTANTS.ONE] === COMMON_CONSTANTS.PDF
          ) {
            return API_RESPONSE.TRUE;
          }
          return API_RESPONSE.FALSE;
        });

        if (isValid) {
          resolve(API_RESPONSE.TRUE);
        } else {
          reject(REGISTRATION_ERRORS.PDF_FORMAT);
        }
      } else {
        const isValid: any = [...eventValue].every((media: any) => {
          store.dispatch(setLoader(false));
          if (media.type.split("/")[0] === COMMON_CONSTANTS.IMAGE) {
            return API_RESPONSE.TRUE;
          }
          return API_RESPONSE.FALSE;
        });
        if (isValid) {
          resolve(API_RESPONSE.TRUE);
        } else {
          reject(REGISTRATION_ERRORS.IMAGE_FORMAT);
        }
      }
    });
  };

  /* Handling file drop */
  const handleDrop = (event: any, uploadValue: any) => {
    event.preventDefault();
    event.nativeEvent.preventDefault();
    checkUploadType(event, uploadValue, PERSONAL_INFORMATION.DROP)
      .then((status) => {
        // setCurrentUpload(uploadValue);
        // setUploadType(PERSONAL_INFORMATION.DROP);
        setDropEvent(event);
      })
      .catch((error) => {
        toast.error(error);
        // toast.error('Please upload valid format');
      });
  };

  /* Handle File change */
  const handleChange = (event: any, uploadValue: any) => {

    if (!event.target.files || event.target.files.length === 0) {
      return;
    }
    store.dispatch(setLoader(true));
    event.preventDefault();
    event.nativeEvent.preventDefault();
    checkUploadType(event, uploadValue, PERSONAL_INFORMATION.SELECT)
      .then((status) => {
        setDropEvent(event);
        store.dispatch(setLoader(false));
      })
      .catch((error) => {
        toast.error(error);
        store.dispatch(setLoader(false));
        // toast.error('Please upload valid format');
      });
  };

  /* Handling file drag */
  const handleDragEnter = (event: any) => {
    event.preventDefault();
  };

  /* Handling file drag leave */
  const handleDragLeave = (event: any) => {
    event.preventDefault();
  };

  /* Navigate call */
  const onNavigate = (state: any) => {
    props.activeStatus(state);
  };

  const onDeleteCertificate = (id: any) => {
    let data = certificates;
    data.splice(id, NUMBER_CONSTANTS.ONE);
    setCertificates([...data])
  }

  const onUploadContents = (API: any, payload: any) => {
    axiosInstance
      .put(
        API + `?${VALIDATION_CONSTANT.PAGE}=` + NUMBER_CONSTANTS.THREE,
        payload
      )
      .then((response: any) => {
        if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
          toast.success(response.data.message, TOASTER_CONFIGS);
          if (location.pathname !== ROUTES.PROFILE)
            onNavigate(NUMBER_CONSTANTS.FOUR);
        }
      });
  };

  const onSubmitUploads = (values: any) => {
    if (
      emirates_front &&
      emirates_back &&
      profileImage &&
      certificates &&
      !isSchoolUniversityReg
    ) {
      let payload: any = {
        emirates_id: values.emirates_id,
        immigrant_id: values.immigrant_id,
        emirates_front: emirates_front,
        emirates_back: emirates_back,
        immigrant_front: immigrant_front ? immigrant_front : "",
        immigrant_back: immigrant_back ? immigrant_back : "",
        profile_image: profileImage,
        certificates: certificates,
        tutor_cv: tutorCV,
        camp_broucher: campBrouchers ? campBrouchers : "",
        trade_id: values.trade_id,
        trade_license: tradelicence ? tradelicence : ""
      };

      if (userType === `${NUMBER_CONSTANTS.FIVE}`) {
        onUploadContents(location.pathname === ROUTES.PROFILE ? API_END_POINTS.CAMP_PROFILE_UPDATE : API_END_POINTS.CAMP_PROFESSIONAL_REGISTER, payload);
      } else if (userType === `${NUMBER_CONSTANTS.NINE}`) {
        payload.trainer_cv = tutorCV;
        onUploadContents(
          location.pathname === ROUTES.PROFILE ? API_END_POINTS.TRAINER_PROFILE_UPDATE : API_END_POINTS.PERSONAL_PROFESSIONAL_REGISTER,
          payload
        );
      } else if (userType === `${NUMBER_CONSTANTS.FOUR}`) {
        onUploadContents(location.pathname === ROUTES.PROFILE ? API_END_POINTS.TUTOR_PROFILE_UPDATE : API_END_POINTS.TUTOR_VERIFY, payload);
      } else if (userType === `${NUMBER_CONSTANTS.THREE}`) {
        payload.educational_expert_cv = tutorCV;
        onUploadContents(location.pathname === ROUTES.PROFILE ? API_END_POINTS.TUTOR_PROFILE_UPDATE : API_END_POINTS.EXPERTS_REGISTRATION, payload);
      }
    } else if (
      emirates_front &&
      emirates_back) {
      let payload: any = {
        emirates_id: values.emirates_id,
        immigrant_id: values.immigrant_id,
        emirates_front: emirates_front,
        emirates_back: emirates_back,
        immigrant_front: immigrant_front ? immigrant_front : "",
        immigrant_back: immigrant_back ? immigrant_back : "",
      };
      let type = userType === ADMIN_ROLES.SCHOOL ? NUMBER_CONSTANTS.ONE : NUMBER_CONSTANTS.TWO;
      axiosInstance
        .put(
          API_END_POINTS.SCHOOL_UNIVERSITY_STEPPERS + `?${VALIDATION_CONSTANT.PAGE}=` + NUMBER_CONSTANTS.TWO + `&${VALIDATION_CONSTANT.TYPE_INFO}=` + type,
          payload
        )
        .then((response: any) => {
          if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
            toast.success(response.data.message, TOASTER_CONFIGS);
            if (location.pathname === ROUTES.PROFILE)
              onNavigate(NUMBER_CONSTANTS.THREE);
          }
        });
    } else {

    }
  };

  return (
    <div className="row">
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg -12">
        <FileViewerDialog
          open={fileViewerOpen}
          handleClose={onFilerViewerDialogClose}
          viewerFile={viewerFile}
        ></FileViewerDialog>
        <Card className="pi-wrapper">
          <Formik
            initialValues={initialValue}
            validationSchema={infoValidationSchema}
            enableReinitialize={true}
            onSubmit={(values, actions) => {
              onSubmitUploads(values);
            }}
          >
            {(formik: any) => {
              return (
                <div>
                  <div className="row row-wrap">
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label required-field">{t("ID")}</label>
                        <Field
                          name={PERSONAL_INFORMATION.EMIRATES_ID}
                          className="email-input"
                          placeholder={t("Ex: 784-1234-1234567-1")}
                          onChange={(e: any) => {
                            formik.setFieldValue(
                              PERSONAL_INFORMATION.EMIRATES_ID,
                              e.target.value
                            );
                          }}
                          disabled={editable ? false : true}
                          value={
                            formik.values[PERSONAL_INFORMATION.EMIRATES_ID]
                          }
                          onBlur={formik.handleBlur(
                            PERSONAL_INFORMATION.EMIRATES_ID
                          )}
                          onClick={formik.handleBlur(
                            PERSONAL_INFORMATION.EMIRATES_ID
                          )}
                        />
                        <div className="errorMessage">
                          {formik.touched[PERSONAL_INFORMATION.EMIRATES_ID] &&
                            formik.errors[PERSONAL_INFORMATION.EMIRATES_ID] && (
                              <p>
                                {t(
                                  `${formik.errors[
                                  PERSONAL_INFORMATION.EMIRATES_ID
                                  ]
                                  }`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>

                  </div>

                  <div className="row row-wrap">
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label required-field">
                          {t("ID Front")}
                        </label>
                        {editable && <div
                          className="id-upload-file-wrapper"
                          onDragOver={handleDragOver}
                          onDrop={(e: any) => {
                            handleDrop(e, PERSONAL_INFORMATION.EMIRATES_FRONT);
                          }}
                          onDragEnter={handleDragEnter}
                          onDragLeave={handleDragLeave}
                          ref={uploadFileRef}
                        >
                          <div className="upload-content">
                            <img src={uploadImage} />
                            <div className="text-content">
                              <p className="select-text">Drag files here</p>
                            </div>
                            <input
                              type="file"
                              accept="image/png, image/jpg, image/jpeg, image/svg"
                              className="input-upload"
                              onChange={(e: any) => {
                                handleChange(
                                  e,
                                  PERSONAL_INFORMATION.EMIRATES_FRONT
                                );
                              }}
                              ref={emiratesFrontBtnRef}
                              style={{ display: "none" }}
                            />
                          </div>
                          <button
                            className="select-file-btn"
                            onClick={() => {
                              emiratesFrontBtnRef.current?.click();
                            }}
                          >
                            SELECT FILE
                          </button>
                        </div>}
                        <div className="errorMessage">
                          {!emirates_front && submitted && (
                            <p>{t(`${REGISTRATION_ERRORS.EMIRATES_FRONT}`)}</p>
                          )}
                        </div>
                      </div>
                      {emirates_front && (
                        <div className="image-wrapper">
                          <img
                            className="uploaded-image"
                            src={emirates_front}
                            onClick={() => {
                              onFilerViewerDialogOpen(emirates_front);
                            }}
                          />
                          {/* <img src={closeIcon} className="close-icon" /> */}
                          {editable && <CloseIcon className="close-icon" onClick={() => { setEmiratesFront("") }} />}
                          <p className="pdf-title">
                            {
                              emirates_front.split("/")[
                              emirates_front.split("/").length - 1
                              ]
                            }
                          </p>
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <div
                        className="form-items"
                        onDragOver={handleDragOver}
                        onDrop={(e: any) => {
                          handleDrop(e, PERSONAL_INFORMATION.EMIRATES_BACK);
                        }}
                        onDragEnter={handleDragEnter}
                        onDragLeave={handleDragLeave}
                        ref={uploadFileRef}
                      >
                        <label className="form-label required-field">
                          {t("ID Back")}
                        </label>
                        {editable && <div className="id-upload-file-wrapper">
                          <div className="upload-content">
                            <img src={uploadImage} />
                            <div className="text-content">
                              <p className="select-text">Drag files here</p>
                            </div>
                            {/* <FileUploader
                              //  handleChange={handleChange}
                              name="file"
                              ref={uploadFileRef}
                              className="drag-uploader"
                            /> */}
                            <input
                              type="file"
                              accept="image/png, image/jpg, image/jpeg, image/svg"
                              className="input-upload"
                              onChange={(e: any) => {
                                handleChange(
                                  e,
                                  PERSONAL_INFORMATION.EMIRATES_BACK
                                );
                              }}
                              ref={emiratesBackBtnRef}
                              style={{ display: "none" }}
                            />
                          </div>
                          <button
                            className="select-file-btn"
                            // onClick={()=>{handleBtnClick(PERSONAL_INFORMATION.EMIRATES_BACK)}}
                            onClick={() => {
                              emiratesBackBtnRef.current?.click();
                            }}
                          >
                            SELECT FILE
                          </button>
                        </div>}
                        <div className="errorMessage">
                          {!emirates_back && submitted && (
                            <p>{t(`${REGISTRATION_ERRORS.EMIRATES_BACK}`)}</p>
                          )}
                        </div>
                      </div>
                      {emirates_back && (
                        <div className="image-wrapper">
                          <img
                            className="uploaded-image"
                            src={emirates_back}
                            onClick={() => {
                              onFilerViewerDialogOpen(emirates_back);
                            }}
                          />
                          {editable && <CloseIcon className="close-icon" onClick={() => { setEmiratesBack("") }} />}
                          <p className="pdf-title">
                            {
                              emirates_back.split("/")[
                              emirates_back.split("/").length - 1
                              ]
                            }
                          </p>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="row row-wrap">
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label">
                          {t("Passport")}
                        </label>
                        <Field
                          name={PERSONAL_INFORMATION.IMMIGRANT_ID}
                          className="email-input"
                          placeholder={t("Passport")}
                          disabled={editable ? false : true}
                          onChange={(e: any) => {
                            formik.setFieldValue(
                              PERSONAL_INFORMATION.IMMIGRANT_ID,
                              e.target.value
                            );
                          }}
                          value={
                            formik.values[PERSONAL_INFORMATION.IMMIGRANT_ID]
                          }
                          onBlur={formik.handleBlur(
                            PERSONAL_INFORMATION.IMMIGRANT_ID
                          )}
                          onClick={formik.handleBlur(
                            PERSONAL_INFORMATION.IMMIGRANT_ID
                          )}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row row-wrap">
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label">
                          {t("Passport Front")}
                        </label>
                        {editable && <div
                          className="id-upload-file-wrapper"
                          onDragOver={handleDragOver}
                          onDrop={(e: any) => {
                            handleDrop(e, PERSONAL_INFORMATION.IMMIGRANT_FRONT);
                          }}
                          onDragEnter={handleDragEnter}
                          onDragLeave={handleDragLeave}
                          ref={uploadFileRef}
                        >
                          <div className="upload-content">
                            <img src={uploadImage} />
                            <div className="text-content">
                              <p className="select-text">Drag files here</p>
                            </div>
                            <input
                              type="file"
                              accept="image/png, image/jpg, image/jpeg, image/svg"
                              className="input-upload"
                              onChange={(e: any) => {
                                handleChange(
                                  e,
                                  PERSONAL_INFORMATION.IMMIGRANT_FRONT
                                );
                              }}
                              ref={immigrantFrontBtnRef}
                              style={{ display: "none" }}
                            />
                          </div>
                          <button
                            className="select-file-btn"
                            onClick={() => {
                              immigrantFrontBtnRef.current?.click();
                            }}
                          >
                            SELECT FILE
                          </button>
                        </div>}
                        {/* <div className="errorMessage">
                          {!immigrant_front && submitted && (
                            <p>{t(`${REGISTRATION_ERRORS.IMMIGRANT_FRONT}`)}</p>
                          )}
                        </div> */}
                      </div>

                      {immigrant_front && (
                        <div className="image-wrapper">
                          <img
                            className="uploaded-image"
                            src={immigrant_front}
                            onClick={() => {
                              onFilerViewerDialogOpen(immigrant_front);
                            }}
                          />
                          {editable && <CloseIcon className="close-icon" onClick={() => { setImmigrantFront("") }} />}
                          <p className="pdf-title">
                            {
                              immigrant_front.split("/")[
                              immigrant_front.split("/").length - 1
                              ]
                            }
                          </p>
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label">
                          {t("Passport Back")}
                        </label>
                        {editable && <div
                          className="id-upload-file-wrapper"
                          onDragOver={handleDragOver}
                          onDrop={(e: any) => {
                            handleDrop(e, PERSONAL_INFORMATION.IMMIGRANT_BACK);
                          }}
                          onDragEnter={handleDragEnter}
                          onDragLeave={handleDragLeave}
                          ref={uploadFileRef}
                        >
                          <div className="upload-content">
                            <img src={uploadImage} />
                            <div className="text-content">
                              <p className="select-text">Drag files here</p>
                            </div>
                            <input
                              type="file"
                              accept="image/png, image/jpg, image/jpeg, image/svg"
                              className="input-upload"
                              onChange={(e: any) => {
                                handleChange(
                                  e,
                                  PERSONAL_INFORMATION.IMMIGRANT_BACK
                                );
                              }}
                              ref={immigrantBackBtnRef}
                              style={{ display: "none" }}
                            />
                          </div>
                          <button
                            className="select-file-btn"
                            onClick={() => {
                              immigrantBackBtnRef.current?.click();
                            }}
                          >
                            SELECT FILE
                          </button>
                        </div>}
                      </div>
                      {immigrant_back && (
                        <div className="image-wrapper">
                          <img
                            className="uploaded-image"
                            src={immigrant_back}
                            onClick={() => {
                              onFilerViewerDialogOpen(immigrant_back);
                            }}
                          />
                          {editable && <CloseIcon className="close-icon" onClick={() => { setImmigrantBack("") }} />}
                          <p className="pdf-title">
                            {
                              immigrant_back.split("/")[
                              immigrant_back.split("/").length - 1
                              ]
                            }
                          </p>
                        </div>
                      )}
                    </div>
                  </div>

                  {!isSchoolUniversityReg && <div className="row row-wrap">
                    <div className="col-md-12">
                      <div
                        className="form-items"
                        onDragOver={handleDragOver}
                        onDrop={(e: any) => {
                          handleDrop(e, PERSONAL_INFORMATION.PROFILE_IMAGE);
                        }}
                        onDragEnter={handleDragEnter}
                        onDragLeave={handleDragLeave}
                        ref={uploadFileRef}
                      >
                        <label className="form-label required-field">{t("Photo")}</label>
                        <div className="upload-file-wrapper">
                          <div className="upload-content">
                            <img src={uploadImage} />
                            <div className="text-content">
                              <p className="select-text">
                                Select a file or drag and drop here
                              </p>
                              <p className="file-text">
                                Recommended size: 640x671 with JPG,PNG
                              </p>
                            </div>
                          </div>
                          <input
                            type="file"
                            accept="image/png, image/jpg, image/jpeg, image/svg"
                            className="input-upload"
                            onChange={(e: any) => {
                              handleChange(
                                e,
                                PERSONAL_INFORMATION.PROFILE_IMAGE
                              );
                            }}
                            ref={profileBtnRef}
                            style={{ display: "none" }}
                          />
                          <button
                            className="select-file-btn"
                            onClick={() => {
                              profileBtnRef.current?.click();
                            }}
                          >
                            SELECT FILE
                          </button>
                        </div>
                        <div className="errorMessage">
                          {!profileImage && submitted && (
                            <p>{t(`${REGISTRATION_ERRORS.PROFILE_PHOTO}`)}</p>
                          )}
                        </div>
                      </div>
                      {profileImage && (
                        <div className="full-image-wrapper">
                          <img
                            className="uploaded-image"
                            src={profileImage}
                            onClick={() => {
                              onFilerViewerDialogOpen(profileImage);
                            }}
                          />
                          <CloseIcon className="close-icon" onClick={() => { setProfileImage("") }} />
                          <p className="pdf-title">
                            {
                              profileImage.split("/")[
                              profileImage.split("/").length - 1
                              ]
                            }
                          </p>
                        </div>
                      )}
                    </div>
                  </div>}

                  {!isSchoolUniversityReg && <div className="row row-wrap">
                    <div className="col-md-12">
                      <div
                        className="form-items"
                        onDragOver={handleDragOver}
                        onDrop={(e: any) => {
                          handleDrop(e, PERSONAL_INFORMATION.CERTIFICATES);
                        }}
                        onDragEnter={handleDragEnter}
                        onDragLeave={handleDragLeave}
                        ref={uploadFileRef}
                      >
                        <label className="form-label required-field">{t("Certificate")}</label>
                        {editable && <div className="upload-file-wrapper">
                          <div className="upload-content">
                            <img src={uploadImage} />
                            <div className="text-content">
                              <p className="select-text">
                                Select a file or drag and drop here
                              </p>
                              <p className="file-text">
                                JPG,PNG or PDF filesize not more than 10MB
                              </p>
                            </div>
                            <input
                              type="file"
                              accept="image/png, image/jpg, image/jpeg, image/svg"
                              className="input-upload"
                              onChange={(e: any) => {
                                handleChange(
                                  e,
                                  PERSONAL_INFORMATION.CERTIFICATES
                                );
                              }}
                              ref={uploadFileBtnRef}
                              style={{ display: "none" }}
                            />
                          </div>
                          <button
                            className="select-file-btn"
                            onClick={() => {
                              uploadFileBtnRef.current?.click();
                            }}
                          >
                            SELECT FILE
                          </button>
                        </div>}
                        <p className="user-note">
                          {/* <span className="star">*</span> */}Note: Can
                          upload upto three certificates
                        </p>
                        <div className="errorMessage">
                          {certificates?.length === 0 && submitted && (
                            <p>
                              {t(`${REGISTRATION_ERRORS.CERTIFICATE_UPLOAD}`)}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>}

                  {certificates?.length > 0 && (
                    <div className="certificates-wrapper">
                      {certificates?.map((file: any, index: any) => {
                        return file.split(".")[file.split(".").length - 1] ===
                          "pdf" ? (
                          <div className="drive-image-wrapper">
                            <img
                              className="drive-img"
                              src={driveImg}
                              onClick={() => {
                                // onFilerViewerDialogOpen(file);
                                window.open(file, '_blank')
                              }}
                            />
                            {editable && <CloseIcon className="close-icon" onClick={() => { onDeleteCertificate(index) }} />}
                            <p className="pdf-title">
                              {file.split("/")[file.split("/").length - 1]}
                            </p>
                          </div>
                        ) : (
                          <div className="full-image-wrapper">
                            <img
                              className="uploaded-image"
                              src={file}
                              onClick={() => {
                                onFilerViewerDialogOpen(file);
                              }}
                            />
                            {editable && <CloseIcon className="close-icon" onClick={() => { onDeleteCertificate(index) }} />}
                            <p className="pdf-title">
                              {file.split("/")[file.split("/").length - 1]}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {userType === `${NUMBER_CONSTANTS.FIVE}` && (
                    <div className="row row-wrap">
                      <div className="col-md-6">
                        <div className="form-items">
                          <label className="form-label required-field">{t("Trade ID")}</label>
                          <Field
                            name={PERSONAL_INFORMATION.TRADE_ID}
                            className="email-input"
                            placeholder={t("Ex:1234567-1")}
                            onChange={(e: any) => {
                              formik.setFieldValue(
                                PERSONAL_INFORMATION.TRADE_ID,
                                e.target.value
                              );
                            }}
                            // disabled={editable ? false : true}
                            value={
                              formik.values[PERSONAL_INFORMATION.TRADE_ID]
                            }
                            onBlur={formik.handleBlur(
                              PERSONAL_INFORMATION.TRADE_ID
                            )}
                            onClick={formik.handleBlur(
                              PERSONAL_INFORMATION.TRADE_ID
                            )}
                          />
                          <div className="errorMessage">
                            {formik.touched[PERSONAL_INFORMATION.TRADE_ID] &&
                              formik.errors[PERSONAL_INFORMATION.TRADE_ID] && (
                                <p>
                                  {t(
                                    `${formik.errors[
                                    PERSONAL_INFORMATION.TRADE_ID
                                    ]
                                    }`
                                  )}
                                </p>
                              )}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-items">
                          <label className="form-label">
                            {t("Trade licence")}
                          </label>
                          {editable && <div
                            className="id-upload-file-wrapper"
                            onDragOver={handleDragOver}
                            onDrop={(e: any) => {
                              handleDrop(e, PERSONAL_INFORMATION.TRADE_LICENCE);
                            }}
                            onDragEnter={handleDragEnter}
                            onDragLeave={handleDragLeave}
                            ref={uploadFileRef}
                          >
                            <div className="upload-content">
                              <img src={uploadImage} />
                              <div className="text-content">
                                <p className="select-text">Drag files here</p>
                              </div>
                              <input
                                type="file"
                                // accept="image/png, image/jpg, image/jpeg, image/svg"
                                className="input-upload"
                                onChange={(e: any) => {
                                  handleChange(
                                    e,
                                    PERSONAL_INFORMATION.TRADE_LICENCE
                                  );
                                }}
                                ref={tradelicenceBtnRef}
                                style={{ display: "none" }}
                              />
                            </div>
                            <button
                              className="select-file-btn"
                              onClick={() => {
                                tradelicenceBtnRef.current?.click();
                              }}
                            >
                              SELECT FILE
                            </button>
                          </div>}
                        </div>

                        {tradelicence && (
                          <div className="image-wrapper">
                            {tradelicence.split(".")[tradelicence.split(".").length - 1] === "pdf" ?
                            <img
                              className="uploaded-image"
                              src={driveImg}
                              onClick={() => {
                                  window.open(tradelicence, '_blank') 
                              }}
                            /> : <img
                              className="uploaded-image"
                              src={tradelicence}
                              onClick={() => {
                                  onFilerViewerDialogOpen(tradelicence)
                              }}
                            />}
                            {editable && <CloseIcon className="close-icon" onClick={() => { setTradelicence("") }} />}
                            <p className="pdf-title">
                              {tradelicence.split("/")[tradelicence.split("/").length - 1]}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {!isSchoolUniversityReg && userType !== `${NUMBER_CONSTANTS.FIVE}` && <div className="row row-wrap">
                    <div className="col-md-12">
                      <div
                        className="form-items"
                        onDragOver={handleDragOver}
                        onDrop={(e: any) => {
                          handleDrop(e, PERSONAL_INFORMATION.TUTOR_CV);
                        }}
                        onDragEnter={handleDragEnter}
                        onDragLeave={handleDragLeave}
                        ref={uploadFileRef}
                      >
                        <label className="form-label required-field">{t("Upload CV")}</label>
                        {editable && <div className="upload-file-wrapper">
                          <div className="upload-content">
                            <img src={uploadImage} />
                            <div className="text-content">
                              <p className="select-text">
                                Select a file or drag and drop here
                              </p>
                              <p className="file-text">
                                PDF filesize not more than 10MB
                              </p>
                            </div>
                          </div>
                          <input
                            type="file"
                            accept="application/pdf"
                            className="input-upload"
                            onChange={(e: any) => {
                              handleChange(e, PERSONAL_INFORMATION.TUTOR_CV);
                            }}
                            ref={certificateBtnRef}
                            style={{ display: "none" }}
                          />
                          <button
                            className="select-file-btn"
                            onClick={() => {
                              certificateBtnRef.current?.click();
                            }}
                          >
                            SELECT FILE
                          </button>
                        </div>}
                        <div className="errorMessage">
                          {!tutorCV && submitted && (
                            <p>{t(`${REGISTRATION_ERRORS.TUTOR_CV}`)}</p>
                          )}
                        </div>
                      </div>
                    </div>
                    {tutorCV && (
                      <div className="drive-image-wrapper">
                        <img
                          className="drive-img"
                          src={driveImg}
                          onClick={() => {
                            // onFilerViewerDialogOpen(tutorCV);
                            window.open(tutorCV, '_blank')
                          }}
                        />
                        {editable && <CloseIcon className="close-icon" onClick={() => { setTutorCV("") }} />}
                        <p className="pdf-title">
                          {tutorCV.split("/")[tutorCV.split("/").length - 1]}
                        </p>
                      </div>
                    )}
                  </div>}

                  {location.pathname === ROUTES.PROFILE ?
                    <div className="bi-buttons-wrap">

                      <button
                        className="btn btn-next"
                        type="submit"
                        onClick={() => {
                          setSubmitted(true);
                          formik.handleSubmit(); /* onNavigate(4); */
                        }}
                      >
                        Update
                      </button>
                    </div>
                    :
                    <div className="bi-buttons-wrap">
                      <button
                        className="btn btn-back"
                        onClick={() =>
                          onNavigate(userType === ADMIN_ROLES.SCHOOL || userType === ADMIN_ROLES.UNIVERSITY ? 1 : 2)
                        }
                      >
                        Back
                      </button>
                      <button
                        className="btn btn-next"
                        type="submit"
                        onClick={() => {
                          setSubmitted(true);
                          formik.handleSubmit(); /* onNavigate(4); */
                        }}
                      >
                        Next
                      </button>
                    </div>}
                </div>
              );
            }}
          </Formik>
        </Card>
      </div>
    </div>
  );
};

export default PersonalInformation;
